import { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import styles from './employerProfile.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faStar, faSpinner } from '@fortawesome/free-solid-svg-icons';

const baseURL = `${process.env.REACT_APP_API_URL}`

const EmployerProfile = () => {
    const [employer, setEmployer]  = useState(null)
    const [loading, setLoading] = useState(true)
    const  {id}  = useParams();
    const [showContactForm, setShowContactForm] = useState(false)
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [reviews, setReviews] = useState([]);
    const [newReviews, setNewReviews] = useState('')
    const [newRating, setNewRating] = useState()
    const location = useLocation()

    const userType = location.pathname.includes("house_manager")? "house_manager" : "employer";

    useEffect(() => {
        axios
            .get(`${baseURL}/profiles/employer/${id}/`)
            .then((response) => {
                setEmployer(response.data)
                setLoading(false)

                const userId = response.data.user_id
                fetchReviews(userId)
            })
            .catch((error) => {
                console.log(error)
                setLoading(false)
            })
        const fetchReviews = async (userId) => {
            try {
                const response = await axios.get(`${baseURL}/profiles/reviews/${userId}/`)
                setReviews(response.data)
                console.log('Fetch response data:', response.data)
                console.log('CustomUser ID:', userId)
            } catch (error) {
                console.error('Error fetching reviews:', error);
            }
        };
    }, [id, newReviews])

    const handleSendEmployerMessage = () => {
        if (!message.trim()) {
            setError('Message cannot be empty')
            return;
        }
        const token = localStorage.getItem('accessToken');
        if (!token) {
            console.error('AccessToken not found in localStorage');
            setError('Please log in to send a message')
        }
        console.log('AccessToken:', token)
        axios
            .post(
                `${baseURL}/profiles/contact-employer/`,
                {
                    employerId: id,
                    message,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            )
            .then(() => {
                setSuccess("Message has been sent")
                setMessage('');
                setShowContactForm(false)
            })
            .catch((error) => {
                console.error('Error sendind message:', error)
                if (error.response && error.response.status === 401) {
                    setError("Unauthorized, Please login again")
                } else {
                    setError("Error has occurred while sending your message");
                }
            });
    };

    const handleReviewsSubmit = () => {
        if (!newReviews.trim()) {
            setError('Review cannot be empty')
            return;
          }
  
          const token = localStorage.getItem('accessToken')
          if (!token) {
            setError('Please log in to submit a review')
            return;
          }
  
          if (newRating < 1 || newRating > 5) {
            setError('Rating must be between 1 and 5')
            return;
          }
  
          if (!userType || !id) {
            setError('User type or ID not found')
            return;
          }

        axios
            .post(
                `${baseURL}/profiles/reviews_submit/${userType}/${id}/`,
                    {
                        comment: newReviews,
                        rating: newRating,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        },
                    }
            )
            .then((response) => {
                console.log('Submitted new Reviews:', response.data)
                setReviews([...reviews, response.data])
                setSuccess('Review has been submitted')
                setNewReviews('')
                setNewRating(0)
            })
            .catch((error) => {
                console.log('Authorization token:', token)
                console.error('Error submitting reviews:', error)
                if (error.response && error.response.data) {
                    setError(error.response.data.non_field_errors || "An error occurred")
                } else {
                    setError("An error occurred")
                }
            });
    };

    if (!employer) return <h2>No Employer Found</h2>
    if (loading) return (
              <div className={styles.loadingContent}>
                <FontAwesomeIcon icon={faSpinner} spin size="3x" className={styles.spinner} />
                <span className={styles.loadingText}>Loading...</span>
              </div>
            );


    return (
        <div className={styles.profileContainer}>
            {success && (
            <div className={styles.successMessageDiv}>
                {error && <p className={styles.error}>{error}</p>}
                {success && <p className={styles.success}>{success}</p>}
            </div>
            )}
            <div className={styles.header}>
                <div className={styles.leftSection}>
                    <div className={styles.subHeader}>
                        <img
                            src={`${baseURL}${employer.image}`}
                            alt={`${employer.first_name} ${employer.last_name}`}
                            className={styles.profileImage}
                        />
                        <div className={styles.basicInfo}>
                            <h1 className={styles.name}>
                                {employer.first_name} {employer.last_name}
                            </h1>
                            <p className={styles.location}>
                                <FontAwesomeIcon icon={faMapMarkerAlt} style={{color: '#007bff'}}/> {employer.location}
                            </p>
                            <p className={styles.rating}>
                                <FontAwesomeIcon icon={faStar} style={{color: '#f39c12'}} /> {employer.rating.toFixed(1)}/5
                            </p>
                            <button 
                                className={styles.contactButton}
                                onClick={() => setShowContactForm(true)}
                                >
                                Contact Me
                            </button>
                        </div>
                    </div>
                    <div className={styles.reviewForm}>
                        <h3>Leave a Review</h3>
                        <textarea
                            value={newReviews}
                            onChange={(e) => setNewReviews(e.target.value)}
                            placeholder="write your review"
                            className={styles.reviewInput}
                        />
                        <input
                            type="number"
                            min='1'
                            max='5'
                            onChange={(e)=> setNewRating(e.target.value)}
                            value={newRating}
                            placeholder="min 1 and max 5"
                            className={styles.reviewInput}
                        />
                        <button
                            onClick={handleReviewsSubmit}
                            className={styles.reviewButton}
                        >
                            Submit Review
                        </button>
                    </div>
                </div>
                {showContactForm && (
                    <div className={styles.contactForm}>
                        <h2>Contact {employer.first_name} </h2>
                        <textarea
                            className={styles.messageInput}
                            placeholder="Write your message"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                        />
                        <div className={styles.formButton}>
                            <button 
                                className={styles.sendButton} 
                                onClick={handleSendEmployerMessage}>
                                    Send Message
                            </button>
                            <button
                                className={styles.cancelButton}
                                onClick={() =>setShowContactForm(false)}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                )}
                <div className={styles.reviewSection}>
                    <h2>Reviews</h2>
                    <div className={styles.subSection}>
                    {reviews.length > 0 ? (
                        reviews.map((review) => (
                            <div key={review.id} className={styles.review}>
                                <p><FontAwesomeIcon icon={faStar} style={{color: 'orange'}}/> ({review.rating.toFixed(1)}/5)</p>
                                <p>{review.comment}</p>
                                <small>{new Date(review.created_at).toLocaleDateString()}</small> by <strong>{review.reviewer_username}</strong>
                            </div>
                        ))
                    ) : (
                        <p>No reviews yet</p>
                    )}
                    </div>
                </div>
                
            </div>
            <div className={styles.detailSection}>
                <div className={styles.bio}>
                    <h2>About</h2>
                    <p>{employer.bio || "No bio available"}</p>
                </div>
                <div className={styles.detailsGrid}>
                    <div>
                        <h3>Hobbies</h3>
                        <p>{employer.hobbies || "No hobbies available"}</p>
                    </div>
                    <div>
                        <h3>Tribe</h3>
                        <p>{employer.tribe || "No tribe available"}</p>
                    </div>
                    <div>
                        <h3>Description</h3>
                        <p>{employer.description || "No description available"}</p>
                    </div>
                    <div>
                        <h3>House Type</h3>
                        <p>{employer.house_type || "No house type available"}</p>
                    </div>
                    <div>
                        <h3>Number of rooms</h3>
                        <p>{employer.number_rooms || "No number of rooms available"}</p>
                    </div>
                    <div>
                        <h3>Number of people</h3>
                        <p>{employer.number_people || "No number of people available"}</p>
                    </div>
                    <div>
                        <h3>Number of children</h3>
                        <p>{employer.number_children || "No number of children available"}</p>
                    </div>
                    <div>
                        <h3>Contract of duration</h3>
                        <p>{employer.contract_duration || "No contract duration available"}</p>
                    </div>
                    <div>
                        <h3>City</h3>
                        <p>{employer.city || "No city available"}</p>
                    </div><div>
                        <h3>Address</h3>
                        <p>{employer.address || "No address available"}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EmployerProfile;